import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { MetaTagType } from '@toro/common/shared/enum/seo/meta-tag-type.enum';
import { LoggedDomainGuard } from '@toro/common/shared/guards/logged-domain.guard';
import { CustomPreloader } from "./custom-router-preloader";
import { CheckoutStockGuard } from './guards/checkout-stock.guard';
import { TradingViewGuard } from './guards/trading-view.guard';
import { StockAnalysisComponent } from './partials/stock-analysis/stock-analysis.component';
import { PlannedCheckoutComponent } from './partials/stock/checkout/planned-checkout/planned-checkout.component';
import { UnplannedCheckoutComponent } from './partials/stock/checkout/unplanned-checkout/unplanned-checkout.component';
import { StockHomeComponent } from './partials/stock/stockhome/stockhome.component';
import { ChartWrapperComponent } from './partials/tradingview/tradingview-wrapper.component';
import { environment } from '@hub-workspace/apps/stock/src/environments/environment';

export const routes: Routes = [
    {
        path: '',
        component: StockHomeComponent,
        canActivate: [LoggedDomainGuard],
        canActivateChild: [LoggedDomainGuard],
        children: [
            {
                path: '',
                redirectTo: 'explore-o-mercado',
                pathMatch: 'full',
            },

            {
                path: 'investir',
                redirectTo: 'explore-o-mercado',
            },
            {
                path: 'oportunidades',
                redirectTo: 'explore-o-mercado',
            },
            {
                path: 'meus-investimentos',
                loadChildren: () => import('./partials/home/my-investments/my-investments.module').then(m => m.MyInvestmentsModule),
                data: {
                    preload: false
                }
            },
            {
                path: 'explore-o-mercado',
                loadChildren: () => import('./partials/home/market-explorer/market-explorer.module').then(m => m.MarketExplorerModule),
                data: {
                    preload: true
                }
            }
        ],
    },

    {
        path: 'analise/:symbol', component: StockAnalysisComponent,
        data: {
            opportunityPage: false,
            metaData: {
                title: `Análise - Bolsa de Valores | ${ environment.isNewBrand ? "Santander Corretora" : "Toro Investimentos" } `,
                metaTags: [
                    { name: MetaTagType.Description, description: 'Veja a análise do ativo e descubra se é um bom momento para investir' },
                ],
            },
        },
    },

    {
        path: 'analise/:symbol/:tendencia', component: StockAnalysisComponent,
        data: {
            opportunityPage: false,
            metaData: {
                title: `Análise - Bolsa de Valores | ${ environment.isNewBrand ? "Santander Corretora" : "Toro Investimentos" } `,
                metaTags: [
                    { name: MetaTagType.Description, description: 'Veja a análise do ativo e descubra se é um bom momento para investir ' },
                ],
            },
        },
    },

    {
        path: 'oportunidade/:id', component: StockAnalysisComponent,
        data: {
            opportunityPage: true,
            metaData: {
                title: `Oportunidade - Bolsa | ${ environment.isNewBrand ? "Santander Corretora" : "Toro Investimentos" }`,
                metaTags: [
                    {
                        name: MetaTagType.Description,
                        description: 'Veja a oportunidade e descubra se é um bom momento para investir no curto, médio ou longo prazo' },
                ],
            },
        },
    },

    // // Checkout
    { path: 'checkout/planejado',  canActivate: [ CheckoutStockGuard ], component: PlannedCheckoutComponent,
        data: {
            editing: false,
            metaData: {
                title: `Checkout Planejado - Bolsa de Valores | ${ environment.isNewBrand ? "Santander Corretora" : "Toro Investimentos" }`,
            },
        },
    },

    { path: 'checkout/planejado/editar',  canActivate: [ CheckoutStockGuard ], component: PlannedCheckoutComponent,
        data: {
            editing: true,
            metaData: {
                title: `Checkout Planejado - Bolsa de Valores | ${ environment.isNewBrand ? "Santander Corretora" : "Toro Investimentos" }`,
            },
        },
    },

    { path: 'checkout', canActivate: [ CheckoutStockGuard ], component: UnplannedCheckoutComponent,
        data: {
            editing: false,
            metaData: {
                title: `Checkout - Bolsa de Valores | ${ environment.isNewBrand ? "Santander Corretora" : "Toro Investimentos" }`,
            },
        },
    },

    { path: 'checkout/editar', canActivate: [ CheckoutStockGuard ], component: UnplannedCheckoutComponent,
        data: {
            editing: true,
            metaData: {
                title: `Checkout - Bolsa de Valores | ${ environment.isNewBrand ? "Santander Corretora" : "Toro Investimentos" }`,
            },
        },
    },
    {
        path: 'acompanhamento',
        loadChildren: () => import('./partials/stock-tracking/stock-tracking.module').then(m => m.StockTrackingModule)
    },
    {
        path: 'checkout-carteira',
        loadChildren: () => import('./partials/stock/checkout-wallet/checkout-wallet.module').then(m => m.CheckoutWalletModule),
    },
    {
        path: 'carteiras',
        loadChildren: () => import('./partials/investment-portfolio/investment-portfolio.module').then(m => m.InvestmentPortfolioModule),
    },
    {
        path: 'grafico',
        canActivate: [TradingViewGuard],
        component: ChartWrapperComponent
    },
    {
      path: 'grafico/:id',
      canActivate: [TradingViewGuard],
      component: ChartWrapperComponent
    },
    {
        path: 'ofertas-publicas',
        canActivate: [LoggedDomainGuard],
        loadChildren: () => import('./partials/stock-ipo/stock-ipo.module').then(m => m.StockIpoModule),
        data: {
            preload: false
        }
    },
    {
        path: 'trader-advisor',
        canActivate: [LoggedDomainGuard],
        loadChildren: () => import('./partials/trader-advisor/trader-advisor.module').then(m => m.TraderAdvisorModule),
    },
    {
        path: 'clube-trader',
        canActivate: [LoggedDomainGuard],
        loadChildren: () => import('./partials/club-trader/club-trader.module').then(m => m.ClubTraderModule),
    },
];
